enum ModalEnum {
  ERROR_MODAL = 'errorModal',
  SUCCESS_MODAL = 'successModal',
  SPINNER_MODAL = 'spinnerModal',
  CONFIRMED_MODAL = 'confirmedModal',
  CUSTOM_MODAL = 'customModal',
  INPUT_MODAL = 'inputFieldModal',
  SNACKBAR = 'snackbar',
}
  
export default ModalEnum;